import confetti from "canvas-confetti";

export function fireCorrectConfetti(): void {
  confetti({
    particleCount: 60,
    spread: 55,
    origin: { y: 0.7 },
    colors: ["#22c55e", "#16a34a", "#4ade80", "#fbbf24", "#f59e0b"],
    disableForReducedMotion: true,
  });
}

export function fireStreakConfetti(streak: number): void {
  const intensity = Math.min(streak / 10, 1);
  const count = 80 + Math.floor(intensity * 120);

  confetti({
    particleCount: Math.floor(count / 2),
    angle: 60,
    spread: 50,
    origin: { x: 0, y: 0.65 },
    colors: ["#f97316", "#ef4444", "#eab308", "#22c55e"],
    disableForReducedMotion: true,
  });
  confetti({
    particleCount: Math.floor(count / 2),
    angle: 120,
    spread: 50,
    origin: { x: 1, y: 0.65 },
    colors: ["#f97316", "#ef4444", "#eab308", "#22c55e"],
    disableForReducedMotion: true,
  });
}

export function fireLevelUpConfetti(): void {
  const duration = 2000;
  const end = Date.now() + duration;

  function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ["#eab308", "#f59e0b", "#fbbf24", "#fde68a"],
      disableForReducedMotion: true,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ["#eab308", "#f59e0b", "#fbbf24", "#fde68a"],
      disableForReducedMotion: true,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  }

  frame();
}
